<template>
  <section class="video-submit">
    <header class="title-header">
      <span class="back-btn" @click="goBack()">
        <img src="@/assets/images/ic_back.svg" alt />
      </span>
      <h1 class="header-title">Create News</h1>
    </header>
    <div class="video-block">
      <video
        controls :autoplay="false" playsinline
        class="video"
      >
        <source :src="getVideoData" type="video/mp4" />
      </video>
      <!-- <img class="play-icon" src="@/assets/images/ic_play_video.svg" alt @click="playVideo()" /> -->
    </div>
    <div class="bottom-section">
      <div class="field">
        <label for>News Title</label>
        <input type="text" placeholder="Mall91 News" v-model="videoTitle" :disabled="uploadBtn"/>
      </div>
      <span class="s-btn" @click="uploadVideoNews" v-if="!uploadBtn">अपलोड करे</span>
    </div> 
    <!-- submit Popup -->
    <div class="submit-popup" v-if="newsUploaded">
      <div class="content">
        <p>आपके न्यूज़ हमारी टीम के पास पहुंच गयी है। हमारी टीम इसे चेक करके लाइव करके आपको पता देगी</p>
        <router-link tag="span" class="ok-btn" :to="{path: '/dashboard'}">OK</router-link>
      </div>
    </div>

    <CustomToaster :dataValue="toasterData" v-if="isValidDetail" />
    <div class="loader" v-if="loading">
      <img src="@/assets/images/loader.gif" alt="loader" />
    </div>
  </section>
</template>

<script>
import ApiCaller from "@/utils/apicaller";
import constant from "@/utils/constant";
import { SessionHelper, X_AUTH_ID } from "@/utils/session";
import CustomToaster from "@/components/Common/CustomToaster";

export default {
  name: "VideoPreview",
  props:{
      getVideoData:{
          type: String
      },
      clickedNewsData:{
        type: Object
      }
  },
  data() {
    return {
      isValidDetail: false,
      toasterData: {},
      loading: false,
      newsUploaded: false,
      videoTitle: "",
      uploadBtn: false
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    playVideo() {
      let x = document.querySelector(".video");
      x.play();
    },
    uploadVideoNews(){
      this.loading = true
      const obj = {
        task_id: this.$route.query.allTaskIndex,
        news_title: this.videoTitle,
        news: this.getVideoData,
        news_type: 'mp4'
      }
      ApiCaller(
        constant.BASE_API_URL,
        "tasks/submit_news/",
        "post",
        obj
      )
        .then(data => {
          console.log('==uploadVideoNews=', data)
          if(data.success){
            this.$router.replace('/uploaded-news')
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  mounted() {
    console.log('----==-000',this.getVideoData, this.clickedNewsData.news_title)
    if(this.clickedNewsData && this.clickedNewsData.news_title){
      this.videoTitle = this.clickedNewsData.news_title
      this.uploadBtn = true
    }
  }
};
</script>

